// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-d9eb8bb4] .c-radio {\n  border-radius: 10px !important;\n}\n[data-v-d9eb8bb4] .c-radio input + label:after {\n  border-radius: 10px !important;\n}\n", ""]);
// Exports
module.exports = exports;
